module.exports = __webpack_public_path__ + "img/uitbaters.21837331.jpg";